import { render } from "./History.vue?vue&type=template&id=63c9965f&scoped=true"
import script from "./History.vue?vue&type=script&lang=js"
export * from "./History.vue?vue&type=script&lang=js"

import "./History.vue?vue&type=style&index=0&id=63c9965f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-63c9965f"

export default script